/**
 * 法语（法国）
 */
var frFR = {
  locale: 'fr-FR',
  Common: {
    pleaseInput: 'Veuillez saisir',
    pleaseSelect: 'Veuillez sélectionner',
    confirm: 'Confirmer',
    clear: 'Effacer',
    cancel: 'Annuler',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    reset: 'Réinitialiser'
  },
  Exception: {
    emptyData: 'Aucune donnée',
    error: 'Erreur de page. Réessayez plus tard',
    networkError: 'Erreur réseau'
  },
  List: {
    noMoreData: 'Pas de données supplémentaires',
    networkError: 'Erreur réseau',
    clickRetry: 'Réessayer'
  },
  DateRangePicker: {
    startTime: 'Heure de début',
    endTime: 'Heure de fin',
    timeRange: 'Plage horaire'
  }
};

export { frFR as default };
